'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = exports.sectionStyles = exports.colorScheme = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  ', ';\n\n  & > ', ' > ', ' {\n    margin: 0 auto;\n  }\n  & > ', ' > ', ' + ', '{\n    margin-top: 1em;\n  }\n'], ['\n  ', '\n  ', ';\n\n  & > ', ' > ', ' {\n    margin: 0 auto;\n  }\n  & > ', ' > ', ' + ', '{\n    margin-top: 1em;\n  }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SectionTitle = require('./SectionTitle');

var _SectionContent = require('./SectionContent');

var _SectionImage = require('./SectionImage');

var _helpers = require('./helpers');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var darkColorScheme = '\n  background: ' + _styles.styles.colors.darkbg + ';\n  color: ' + _styles.styles.colors.lightfg + ';\n';
var lightColorScheme = '\n  background: ' + _styles.styles.colors.mediumbg + ';\n  color: ' + _styles.styles.colors.darkfg + ';\n';
var defaultColorScheme = '\n  background: ' + _styles.styles.colors.lightbg + ';\n  color: ' + _styles.styles.colors.mediumfg + ';\n';

var colorScheme = exports.colorScheme = R.cond([[R.has('dark'), R.always(darkColorScheme)], [R.has('light'), R.always(lightColorScheme)], [R.T, R.always(defaultColorScheme)]]);

var TitleWrap = (0, _helpers.wrapComponent)(_SectionTitle.SectionTitle);

var sectionStyles = exports.sectionStyles = '\n  padding: 1em;\n  text-align: center;\n\n  @media ' + _styles.styles.media.tablet + ' {\n    padding: 3em 1.5em;\n  }\n';
/*::
export type SectionProps = {|
  id?: string,
  className?: string,
  dark?: bool,
  light?: bool,
  image?: string,
  title: string | React.Element<*>,
  children: React.Node,
|}
*/
var Section /*: ComponentType<SectionProps> */ = (0, _styledComponents2.default)(function (_ref) {
  var id = _ref.id,
      props = _objectWithoutProperties(_ref, ['id']);

  return React.createElement(
    'section',
    { id: id, className: props.className },
    React.createElement(
      _SectionContent.SectionContent,
      null,
      TitleWrap(props.title),
      props.children,
      (0, _helpers.wrapComponentProp)(_SectionImage.SectionImage, 'src', props.image)
    )
  );
})(_templateObject, sectionStyles, colorScheme, _SectionContent.SectionContent, _SectionImage.SectionImage, _SectionContent.SectionContent, _SectionImage.SectionImage, _SectionTitle.SectionTitle);
exports.Section = Section;
Section.displayName = 'Section';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Section.js
// module id = 45
// module chunks = 0